<template>
  <section class="Page">
    <Header class="Page__header" v-bind="accountHeader" />
    <div class="Page__inner">
      <img
        src="@spectee/assets/images/img_serverError.png"
        alt=""
        width="240"
        height="240"
      />
      <Heading
        class="Page__heading"
        heading="ご指定のページは表示できませんでした"
        type="tertiary"
        level="2"
      />
      <p class="Page__text">時間をおいて再接続をお試しください。</p>
    </div>
  </section>
</template>

<script>
import Heading from '@spectee/components/Atoms/Heading/index.vue';
import Header from '@spectee/components/Organisms/Header/index.vue';

export default {
  name: 'ServerError',
  components: {
    Header,
    Heading,
  },
  data() {
    return {
      accountHeader: {
        color: 'black',
      },
    };
  },
};
</script>

<style lang="scss" scoped>
@use '@spectee/assets/scss/_pageForward.scss' as *;

.Page {
  &__inner {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: $service-unit * 27;
  }

  & &__heading,
  &__text {
    margin-top: $service-unit * 6;
  }

  &__text {
    font-size: $service-font-size-p;
    line-height: $service-line-height-mf;
  }
}
</style>
